import {epos2Axios, goAxios} from "@/interceptors/axios";

class RFIDService {
    getRFIDAccounts() {
        return epos2Axios.get('/api/customers/filter?fields[rfid_account]=1');
    }

    getAccountGarmentType(customer_id) {
        return epos2Axios.get('/api/customers/'+customer_id+'/garmenttype');
    }
    getAccountGarmentTypeService(garmenttype_id) {
        return epos2Axios.get('/api/serviceprices?garmenttype_id=' + garmenttype_id);
    }
    checkUserUniquepw(userid, uniquepw) {
        return goAxios.get('/api/users/' + userid+'/check?field=uniquepw&value=' + uniquepw);
    }
    checkManagerByPin(userid, uniquepw) {
        return goAxios.get('/api/users/' + userid+'/check?field=pin&value=' + uniquepw + '&purpose=manager_pin');
    }
    startScan() {
        return goAxios.put('/api/rfid/start-reader');
    }
    stopScan() {
        return goAxios.put('/api/rfid/stop-reader');
    }
    processOrder(order_id) {
        return goAxios.post('/api/orders/' + order_id+'/process');
    }
    resetProcessingScan(order_id, rogue_items, scanned_items) {
        //return goAxios.delete('/api/orders/'+order_id+'/scanned-items/?rogue_items=' + rogue_items + '&scanned_items=' + scanned_items);
        return goAxios.delete(
            '/api/orders/' + order_id + '/scanned-items',
            {
                data: {
                    rogue_items,
                    scanned_items
                }
            }
        );
    }
    applyAllCustomerGarments(customer_id, tagsapplied) {
        return goAxios.post('/api/customers/'+customer_id+'/garments',{
           tags:tagsapplied
        });
    }
    resolveRogueItems(order_id, rogue_item_ids, garment_type_id, manager_pin, action, service_type_id = null) {
       const payload = {
           rogue_item_ids: rogue_item_ids,
           garment_type_id: garment_type_id,
           manager_pin: manager_pin,
           action: action,
       };
       if (service_type_id) {
           payload.servicetype_id = service_type_id;
       }
       return goAxios.post('/api/orders/' + order_id + '/rogues', payload);
    }
    rejectRogueItemsAtFolding(order_id, rogue_item_ids) {
        return goAxios.post('/api/orders/' + order_id + '/rogues/reject-folding', {
            rogue_item_ids,
        });
    }

    async searchRFIDAssociationLogsList(serverOptions) {
        try {
           let params = "start_date="+serverOptions.start_date
                +"&end_date="+serverOptions.end_date
                +"&search="+serverOptions.search
                +"&page="+serverOptions.page
                +"&limit="+serverOptions.rowsPerPage
                +"&sort_by="+serverOptions.sortBy
                +"&sort_type="+serverOptions.sortType
                +"&type=list";
            const response = await goAxios.get('/api/rfid/logs/batches?'+params);
            return {
                serverCurrentPageItems: response.data.data.batches,
                serverTotalItemsLength: response.data.data.pagination.total,
            };
        } catch (error) {
            console.error('Error fetching data:', error);
            return {
                serverCurrentPageItems: [],
                serverTotalItemsLength: 0,
            };
        }
    }
    async downloadRFIDAssociationLogs(serverOptions) {
        try {
            let params = "start_date="+serverOptions.start_date
                +"&end_date="+serverOptions.end_date
                +"&search="+serverOptions.search
                +"&type="+ serverOptions.type;

            const response = await goAxios.get('/api/rfid/logs/batches?'+params);
            const anchor = document.createElement('a');
            anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(response.data);
            anchor.target = '_blank';
            anchor.download = 'RFIDAssociationLogs.csv';
            anchor.click();
        } catch (error) {
            console.error('Error fetching data:', error);
            return {
                serverCurrentPageItems: [],
                serverTotalItemsLength: 0,
            };
        }
    }

    reassignGarmentsToCustomer(batch_id, pin, customer_id, garmenttype_id, service_id) {

        let params = "customer_id="+customer_id
            +"&pin="+pin
            +"&garmenttype_id="+garmenttype_id
             +"&service_id="+service_id;
        return goAxios.put('/api/rfid/logs/batches/'+batch_id+'/garments?'+params);
    }

    async searchRFIDAssociationLogs(batch_id, serverOptions) {
        try {
            let params = "start_date="+serverOptions.start_date
                +"&end_date="+serverOptions.end_date
                +"&search="+serverOptions.search
                 +"&limit="+serverOptions.rowsPerPage
                +"&page="+serverOptions.page;
            const response = await goAxios.get('/api/rfid/logs/batches/'+batch_id+'?'+params);
            return {
                serverCurrentPageItems: response.data.data.logs,
                serverTotalItemsLength: response.data.data.pagination.total,
            };
        } catch (error) {
            console.error('Error fetching data:', error);
            return {
                serverCurrentPageItems: [],
                serverTotalItemsLength: 0,
            };
        }
    }

     async searchRFIDRogueLogsList(serverOptions) {
        try {
            let params = "search="+serverOptions.search
                +"&limit="+serverOptions.rowsPerPage
                +"&page="+serverOptions.page
                +"&sort_type="+serverOptions.sortType
                +"&sort_by="+serverOptions.sortBy
                +"&resolved="+serverOptions.resolved;
                
            const response = await goAxios.get('/api/orders/rogues?'+params);
            return {
                serverCurrentPageItems: response.data.data.orders,
                serverTotalItemsLength: response.data.data.pagination.total,
            };
        } catch (error) {
            console.error('Error fetching data:', error);
            return {
                serverCurrentPageItems: [],
                serverTotalItemsLength: 0,
            };
        }
    }
     async getRFIDRogueOrderItems(order_id) {
        try {
            const response = await goAxios.get('/api/orders/'+order_id+'/rogues');
            return {
                serverCurrentPageItems: response.data.data.rogue_garments,
            };
        } catch (error) {
            console.error('Error fetching data:', error);
            return {
                serverCurrentPageItems: [],
            };
        }
    }

    startFolding(barcode) {
        return goAxios.post('/api/servicetickets/' + barcode + '/start-folding');
    }

    stopFolding(barcode) {
        return goAxios.post('/api/servicetickets/' + barcode + '/stop-folding');
    }
  
    startPieceUp(barcode, itemsApplied, qpup = false) {
        const params = new URLSearchParams();
        if (qpup) params.append('qpup', '1');
        const queryString = params.toString();

        return goAxios.post(
            '/api/servicetickets/' + barcode + '/start-pieceup-bed' + (queryString ? '?' + queryString : ''),
            {
                items: itemsApplied
            }
        );
    }

    stopSmartshelfLights() {
        return goAxios.get('/api/smartshelf/stop-all-lights');
    }
    getSmartshelves() {
        return goAxios.get('/api/smartshelf');
    }

}

export default new RFIDService();
